<template>
    <div class="app-contacts-contacts-edit">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Editar Contato</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <!-- Formulário de contato [ Criação, Edição ] -->
        <mu-form-contact type="edit"></mu-form-contact>

    </div>
</template>

<script>
    export default {
        name: 'app-contacts-contacts-create',
        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Meus Contatos',
                        route: 'app.contacts.contacts',
                        disabled: false
                    },
                    {
                        text: 'Editar Contato',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>

<style lang="stylus" scoped>

    .mu-button-float-right
        float right

    .contacts-contacts
        padding 20px
        color #333

        .mu-title
            margin 3px 0 8px 0

        .statistics
            padding 20px 0
            color #777
            .text-right
                text-align right

            &.mu-loading
                text-align center
                .text
                    padding-left 10px
                    font-size 12px

        .user-cost
            padding 20px 0

            .user
                .text
                    padding-left 6px

            .cost
                font-size 18px
                text-align right
                color #777
                strong
                    color #388E3C
                    font-weight 900

        .message
            font-size 12px
            padding-top 10px

    .contacts
        margin 20px 0

        .row
            margin 0 20px
            padding 15px 0

            .text-right
                text-align right

        .paginate
            padding 20px

        .mu-paper
            padding 0px

    .cancel
        background #F44336
        padding 20px
        color #fff

        .title
            i
                font-size 18px !important
            strong
                font-size 16px
                padding-left 5px

        .text-center
            text-align center

        .text-right
            text-align right

</style>
